// @flow

import { isLocalFx } from '@tectonics/prs/money';
import { getMainReceipt, getFX } from '@tectonics/prs/receipts';
import { type IncomingPayment } from './types';
import { getReceipts } from './get-receipts';

export function isLocalPayment(incomingPayment: IncomingPayment): bool {
  const receipts = getReceipts(incomingPayment);
  const receipt = getMainReceipt(receipts);
  const fx = getFX(receipt);
  return isLocalFx(fx);
}
